"use client";

import dynamic from "next/dynamic";

const GoogleAnalytics = dynamic(
	() => import("@next/third-parties/google").then((m) => m.GoogleAnalytics),
	{ ssr: false }
);

export function AnalyticsWrapper({ gaId }: { gaId: string }) {
	return (
		<>
			<GoogleAnalytics gaId={gaId} />
		</>
	);
}
